import { MutationTree } from 'vuex';
import { PaginatedResult } from '../types';
import * as MT from './mutationsTypes';
import { IMrtState } from './state';

/*--------------------------------------------------/
 * MRT Mutations
 *--------------------------------------------------*/
export const MrtMutations: IMrtMutations = {
  [MT.SET_MACHINE_READABLE_TEMPLATES]: (
    state: IMrtState,
    machineReadableTemplates: PaginatedResult
  ) => (state.machineReadableTemplates = machineReadableTemplates)
};

/*--------------------------------------------------/
 * MRT Mutations Tree Interface
 *--------------------------------------------------*/
export interface IMrtMutations extends MutationTree<IMrtState> {
  [MT.SET_MACHINE_READABLE_TEMPLATES](
    state: IMrtState,
    machineReadableTemplates: PaginatedResult
  ): void;
}
